angular
    .module('dealerware.web.data')
    .factory('DealerwareContractModel',
        function ($http,
                  Model,
                  $q,
                  DealerwareVehicleContractCollection,
                  DealerwareIssueCollection,
                  DealerwareWarrantyModel,
                  DealerwareAdditionalDriverCollection,
                  $mobilityCompanyAuthentication,
                  PdfHelperService,
                  DataUtils,
                  $dealerwareInternationalizationDateFormats) {

            var parseDate = function(dt) {
                return $dealerwareInternationalizationDateFormats.parseDateForRequest(dt, "YYYY-MM-DD");
            };

            var toLocalTimestamp = function(timestamp) {
                return timestamp ? DataUtils.getInstance().formatTimestampSimple(timestamp, $mobilityCompanyAuthentication.location.time_zone_name) : undefined;
            };

            var toLocalTime = function(timestamp) {
                return timestamp ? moment(timestamp).tz($mobilityCompanyAuthentication.location.time_zone_name).format('kk:mm:ss') : undefined;
            };

            var model = new Model({
                baseEndpoint: '/locations/:location_id/reservations/',
                rootNode: 'reservation',
                customActions: {
                    create: {
                        method: 'POST',
                        ignoreDefaultRootNodeResponse: true,
                        ignoreAssociations: true
                    },
                    update: {
                        method: 'PUT',
                        endpoint: '/locations/:location_id/reservations/:id',
                        ignoreDefaultRootNodeResponse: true,
                        ignoreAssociations: true
                    },
                    loadContractDetails: {
                        method: 'GET',
                        endpoint: '/locations/:location_id/reservations/:id',
                        ignoreDefaultRootNodeResponse: true,
                        ignoreAssociations: true
                    },
                    loadDriversLicense: {
                        method: 'GET',
                        endpoint: '/locations/:location_id/reservations/:id/drivers_license',
                        ignoreDefaultRootNodeResponse: true,
                        ignoreAssociations: true
                    },
                    loadInsurance: {
                        method: 'GET',
                        endpoint: '/locations/:location_id/reservations/:id/insurances',
                        ignoreDefaultRootNodeResponse: true,
                        ignoreAssociations: true
                    },
                    loadInsuranceImage: {
                        method: 'GET',
                        endpoint: '/locations/:location_id/reservations/:id/assets/insurances',
                        ignoreDefaultRootNodeResponse: true,
                        ignoreAssociations: true
                    },
                    deleteInsuranceImage: {
                        method: 'DELETE',
                        endpoint: '/locations/:location_id/reservations/:id/assets/insurances'
                    },
                    saveInsurance: {
                        method: 'POST',
                        endpoint: '/locations/:location_id/reservations/:id/insurances',
                        ignoreDefaultRootNodeResponse: true,
                        ignoreAssociations: true
                    },
                    handleOutstandingBalance: {
                        method: 'PUT',
                        endpoint: '/locations/:location_id/reservations/:id/statement/settle',
                        ignoreDefaultRootNodeResponse: true,
                        ignoreAssociations: true
                    },
                    start: {
                        method: 'PUT',
                        endpoint: '/locations/:location_id/reservations/:id/manual_start',
                        ignoreDefaultRootNodeResponse: true,
                        ignoreAssociations: true
                    },
                    finish: {
                        method: 'PUT',
                        endpoint: '/locations/:location_id/reservations/:id/manual_finish',
                        ignoreDefaultRootNodeResponse: true,
                        ignoreAssociations: true
                    },
                    cancel: {
                        method: 'PUT',
                        endpoint: '/locations/:location_id/reservations/:id/cancel',
                        ignoreDefaultRootNodeResponse: true,
                        ignoreAssociations: true
                    },
                    modify: {
                        method: 'PUT',
                        endpoint: '/locations/:location_id/reservations/:id/modify',
                        ignoreDefaultRootNodeResponse: true,
                        ignoreAssociations: true
                    },
                    modifyStarted: {
                        method: 'PUT',
                        endpoint: '/locations/:location_id/reservations/:id/extend',
                        ignoreDefaultRootNodeResponse: true,
                        ignoreAssociations: true
                    },
                    currentInvoice: {
                        method: 'GET',
                        endpoint: '/locations/:location_id/reservations/:id/receipt',
                        ignoreDefaultRootNodeResponse: true,
                        ignoreAssociations: true
                    },
                    updateCreditCard: {
                        endpoint: '/locations/:location_id/reservations/:id/credit_card',
                        method: 'PUT',
                        ignoreDefaultRootNodeResponse: true,
                        ignoreAssociations: true
                    },
                    loadAvailableAdjustments: {
                        endpoint: '/locations/:location_id/reservations/:id/statement/adjustments/available',
                        method: 'GET',
                        ignoreDefaultRootNodeResponse: true,
                        ignoreAssociations: true
                    },
                    applyBalanceAdjustment: {
                        endpoint: '/locations/:location_id/reservations/:id/statement/adjustments',
                        method: 'POST',
                        rootNodeRequest: 'adjustment',
                        ignoreDefaultRootNodeResponse: true,
                        ignoreAssociations: true
                    },
                    clearAdjustments: {
                        endpoint: '/locations/:location_id/reservations/:id/statement/adjustments',
                        method: 'DELETE'
                    }
                },
                requestTransforms: {
                    create: function(args, data) {
                        if (data.reservation_insurances_attributes && data.reservation_insurances_attributes.length && data.reservation_insurances_attributes[0].expires_on) {
                            data.reservation_insurances_attributes[0].expires_on = parseDate(data.reservation_insurances_attributes[0].expires_on);
                        }
                    },
                    saveInsurance: function(args, data) {
                        var origData = $.extend(true, {}, data);

                        $.each(data, function(k,v) { delete data[k]; });

                        $.extend(data, {
                            id: origData.id,
                            reservation_insurances_attributes: origData.reservation_insurances_mapped
                        });

                        if (data.reservation_insurances_attributes && data.reservation_insurances_attributes[0].expires_on) {
                            data.reservation_insurances_attributes[0].expires_on = parseDate(data.reservation_insurances_attributes[0].expires_on);
                        }
                    }
                },
                responseTransforms: {
                    loadContractDetails: function(args, data) {
                        data.created_at_display = toLocalTimestamp(data.created_at);
                        data.updated_at_display = toLocalTimestamp(data.updated_at);
                        data.pickup_display = toLocalTimestamp(data.pickup);
                        data.local_pickup_time = toLocalTime(data.pickup);
                        data.actual_pickup_display = toLocalTimestamp(data.actual_pickup);
                        data.dropoff_display = toLocalTimestamp(data.dropoff);
                        data.local_dropoff_time = toLocalTime(data.dropoff);
                        data.actual_dropoff_display = toLocalTimestamp(data.actual_dropoff);
                        data.length_of_loan = moment(data.actual_dropoff).diff(moment(data.actual_pickup), 'days', true);
                    },
                    loadInsurance: function(args, data) {
                        if (data.length && data[0].expires_on) {
                            data[0].expires_on = $dealerwareInternationalizationDateFormats.parseDateToDisplayOnTheApplication(data[0].expires_on, ['YYYY-MM-DD']);
                        }
                    },
                    loadDriversLicense: function(args, data) {
                        data.date_of_birth = $dealerwareInternationalizationDateFormats.parseDateToDisplayOnTheApplication(data.date_of_birth, ['YYYY-MM-DD', 'MM-DD-YYYY']);
                        data.expiration = $dealerwareInternationalizationDateFormats.parseDateToDisplayOnTheApplication(data.expiration, ['YYYY-MM-DD', 'MM-DD-YYYY']);
                    },
                    loadAvailableAdjustments: function(args, data) {
                        data.forEach(function(record) {
                            record.label = toButtonLabel(record.name);
                            record.pricing_key = toPricingKey(record.name);
                            record.hide_button = record.pricing_key === 'rental' ? true : false;
                        });
                    }
                }
            });

            function toButtonLabel(name) {
                return {
                    'Daily Rate': 'Loan',
                    'Cleaning Charge': 'Cleaning',
                    'Damage Charge': 'Damage',
                    'Fuel Charge': 'Fuel',
                    'Fuel Service Charge': 'Fuel Service',
                    'Toll Charge': 'Toll',
                    'Generic Charge': 'Other',
                    'Tickets and Violations': 'Ticket/Violation'
                }[name] || name;
            }

            function toPricingKey(name) {
                return {
                    'Daily Rate': 'rental',
                    'Cleaning Charge': 'cleaning',
                    'Damage Charge': 'damage',
                    'Excess Mileage': 'odometer_charge',
                    'Fuel Charge': 'fuel',
                    'Fuel Service Charge': 'fuel_service_charge',
                    'Toll Charge': 'tolls',
                    'Warranty': 'warranty',
                    'Generic Charge': 'adjustments',
                    'Tickets and Violations': 'tickets_and_violations'
                }[name] || name;
            }

            jQuery.extend(model.prototype,{
                searchDisplay: function() {
                    var _confirmation = (this.data && isObject(this.data) && this.data.hasOwnProperty('confirmation_token') && this.data.confirmation_token)  ? this.data.confirmation_token : '';
                    var _state = (this.data && isObject(this.data) && this.data.hasOwnProperty('current_state') && this.data.current_state)  ? this.data.current_state : '';
                    return (_confirmation && _state) ? ( _confirmation + " (" + _state + ")") : _confirmation;
                }
            });

            model.loadVehicleContracts = function(args) {
                DealerwareVehicleContractCollection.forContract({
                    params: args.params,
                    successCallback: (args && isObject(args) && args.hasOwnProperty('successCallback')) ? args.successCallback : noop,
                    errorCallback: (args && isObject(args) && args.hasOwnProperty('errorCallback')) ? args.errorCallback : noop
                });
            };

            model.loadVehicleIssues = function(args) {
                DealerwareIssueCollection.forContract({
                    params: args.params,
                    successCallback: (args && isObject(args) && args.hasOwnProperty('successCallback')) ? args.successCallback : noop,
                    errorCallback: (args && isObject(args) && args.hasOwnProperty('errorCallback')) ? args.errorCallback : noop
                });
            };

            model.loadAdditionalDrivers = function(args) {
                DealerwareAdditionalDriverCollection.index({
                    params: args.params,
                    successCallback: (args && isObject(args) && args.hasOwnProperty('successCallback')) ? args.successCallback : noop,
                    errorCallback: (args && isObject(args) && args.hasOwnProperty('errorCallback')) ? args.errorCallback : noop
                });
            };

            model.loadWarranty = function(args) {
                DealerwareWarrantyModel.get({
                    params: args.params,
                    successCallback: (args && isObject(args) && args.hasOwnProperty('successCallback')) ? args.successCallback : noop,
                    errorCallback: (args && isObject(args) && args.hasOwnProperty('errorCallback')) ? args.errorCallback : noop
                });
            }

            model.getLoanerAgreementPdf = function (contract) {
                return model.getPdf ('/locations/' + contract.locationId + '/reservations/'
                    + contract.contractId + '/rental_agreements/pdf.pdf'
                );
            };

            model.getReceiptPdf = function (contract) {
                return model.getPdf ('/locations/' + contract.locationId + '/reservations/'
                    + contract.contractId + '/receipts/pdf.pdf'
                );
            };

            model.getPdf = function(endpoint) {

                var deferred = $q.defer();

                PdfHelperService.getPdfBlob({
                    endpoint: endpoint
                })
                    .then(
                        function (response) {
                            deferred.resolve(response);
                        },
                        function (response) {
                            deferred.reject(response);
                        }
                    );

                return deferred.promise;
            };

            return model;
});
